import bishop from "./bishop";
import king from "./king";
import knight from "./knight";
import pawn from "./pawn";
import queen from "./queen";
import rook from "./rook";

const pieceMoves = {
    bishop,
    king,
    knight,
    pawn,
    queen,
    rook,
};

export default pieceMoves;